import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getCountriesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileNotCompleted/set-profile")({
    loader: async ({context}) => {
        const countriesResult = await getCountriesWithCaching({
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
        });
        if (countriesResult.success === false) {
            throw countriesResult.error;
        }
        const countries = countriesResult.data;

        return {
            intellsysBaseUrl: context.intellsysBaseUrl,
            countries: countries,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
